import React from 'react';

import { Section } from '@gogame/components';

import { General } from './General';

export const GeneralSection = ({ isEdit }) => {
  return (
    <Section title={'General'}>
      <General isEdit={isEdit} />
    </Section>
  );
};
